import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { CountriesDataService, CountriesColumnsService } from '../../../services';
import { Country, CountriesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-country-details',
  templateUrl: './country-details.component.html',
  styleUrls: ['./country-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class CountryDetailsComponent implements OnInit, OnDestroy {

  public country: Country = {};
  public countries: Country[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private countriesDataService: CountriesDataService,
    private countriesColumnsService: CountriesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Country - Details');
        this.getCountry(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.country !== 'undefined') {
      this.country = this.dynamicDialogConfig.data.country;
    }
    this.columns = this.countriesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getCountry(id: number): void {
    this.isLoading = true;
    this.countriesDataService.getCountry(id).subscribe((response: Country|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.country = response;
      }
    });
  }

  list() {
    this.router.navigate(['/countries']);
  }

  add() {
    this.router.navigate(['/countries/add']);
  }

  edit() {
    this.router.navigate(['/countries/edit/' + this.country.id]);
  }

}
@Component({
  selector: 'app-country-details',
  templateUrl: './country-details.component.html',
  styleUrls: ['./country-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogCountryDetailsComponent extends CountryDetailsComponent {
}

